// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: caption lines from the Teams window (TeamsFollow): one line per Teams caption entry, finished
// once it stops changing or the same speaker starts the next one.

/** A line that has not changed for this long is finished. */
export const SETTLE_MS = 4_000;
export const MAX_LINES = 4000;

export interface FollowLine {
	id: number;
	speaker: string;
	text: string;
	at: number;
	updatedAt: number;
	final: boolean;
}

export type CaptionEvent = {id: number; speaker: string; text: string; at: number};

/** Pure: the lines with one caption folded in (by the Teams entry it came from). */
export function foldCaption(lines: ReadonlyArray<FollowLine>, caption: CaptionEvent, now: number): Array<FollowLine> {
	const next = lines.map((line) =>
		// A speaker's earlier line is finished once they start a new one.
		!line.final && line.speaker === caption.speaker && line.id !== caption.id ? {...line, final: true} : line,
	);
	const index = next.findIndex((line) => line.id === caption.id);
	const line: FollowLine = {
		id: caption.id,
		speaker: caption.speaker,
		text: caption.text,
		at: index >= 0 ? next[index].at : caption.at,
		updatedAt: now,
		final: false,
	};
	if (index >= 0) next[index] = line;
	else next.push(line);
	return next.length > MAX_LINES ? next.slice(-MAX_LINES) : next;
}

/** Pure: lines that have not changed for SETTLE_MS are finished. */
export function settleLines(lines: ReadonlyArray<FollowLine>, now: number): Array<FollowLine> | null {
	let changed = false;
	const next = lines.map((line) => {
		if (line.final || now - line.updatedAt < SETTLE_MS) return line;
		changed = true;
		return {...line, final: true};
	});
	return changed ? next : null;
}
